import { checkoutRequest } from './checkoutRequest'
import {buildPaymentDueCents, type BuildPaymentMode} from '../../shared/buildPayment'
import { blissJobsiteQualifiesForFullService } from '../utils/blissServiceArea'

export interface QuoteDepositCheckoutInput {
  paymentMode?: BuildPaymentMode
  embedded?: boolean
  quoteRequestId: string
  name: string
  email: string
  phone?: string
  projectZip?: string
  projectTotal: number
  consultPaid: boolean
}

export interface QuoteDepositCheckoutResult {
  success: boolean
  clientSecret?: string
  publishableKey?: string
  checkoutUrl?: string
  sessionId?: string
  error?: string
}

export async function startQuoteDepositCheckout(
  input: QuoteDepositCheckoutInput,
): Promise<QuoteDepositCheckoutResult> {
  const amountCents = buildPaymentDueCents(input.projectTotal, input.consultPaid, input.paymentMode)
  if (amountCents <= 0) {
    return { success: false, error: 'No deposit due' }
  }
  if (!blissJobsiteQualifiesForFullService(input.projectZip || '')) {
    return {
      success: false,
      error:
        'Full Service fabrication is not available at this jobsite ZIP (west of Orange Beach, Alabama). The quoted Design Only service and $149 room consultation are still available.',
    }
  }

  return checkoutRequest('/api/create-quote-deposit-checkout', {
    embedded: input.embedded,
    paymentMode: input.paymentMode ?? "deposit",
    quoteRequestId: input.quoteRequestId,
    name: input.name,
    email: input.email,
    phone: input.phone,
    projectZip: input.projectZip,
    projectTotal: input.projectTotal,
    consultPaid: input.consultPaid,
    amountCents,
  })
}

